import { z } from 'zod';
/**
 * Supported locales. `aeb` is Tunisian Arabic (ISO 639-3), written in Arabic script and RTL.
 * Mirrors the CHECK constraints on users.preferred_locale and tenants.*_locale(s).
 */
export const LOCALES = ['ar', 'fr', 'en', 'aeb'];
export const localeSchema = z.enum(LOCALES);
const FALLBACKS = {
    aeb: ['aeb', 'ar', 'fr'],
    ar: ['ar', 'fr'],
    fr: ['fr'],
    en: ['en', 'fr'],
};
/** Resolution order for a requested locale. `aeb → ar → fr` is a product requirement. */
export function localeFallbackChain(locale) {
    return FALLBACKS[locale];
}
export function textDirection(locale) {
    return locale === 'ar' || locale === 'aeb' ? 'rtl' : 'ltr';
}
/** Picks the best available translation following the fallback chain, then `fallback`. */
export function pickLocalized(text, locale, fallback) {
    for (const candidate of [...localeFallbackChain(locale), fallback]) {
        const value = text[candidate];
        if (value !== undefined && value.length > 0)
            return value;
    }
    return undefined;
}
//# sourceMappingURL=locale.js.map